import React, { Component } from "react";
import { Modal, Form, Button, Image, ButtonToolbar } from "react-bootstrap";
import { connect } from "react-redux";
import { get, isFunction } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import { DatePicker } from "../../component/DatePicker";
import {
  dayAgo,
  getColor,
  dateFormat,
  isValidArray,
  formatNumber,
  getLocalstorage,
  transformProjectCategoryId
} from "../../helper";
import MOMDesc from "../MOM/MOMDesc";
import { Field } from "../../component";
import {
  addDecisionAction,
  getMinistryListAction,
  getChildIssuesAction
} from "../../actions/addDecision.action";
import { getGroupCategoryIdAction } from "../../actions/createProject.action";
import {
  ERROR_MSG,
  PATHS,
  DOCUMENT_FORMATS,
  ISSUE_DECISION_DETAILS,
  STATUS
} from "../../constant";
import { bindActionCreators } from "redux";
import { getGuestList } from "../../actions/userManagement.action";
import { modifyDataForIssueListPost } from "./helper";
import { getAgendaIssueAction, getMomDetails } from "../../actions/mom.action";
import DecisionAgendaSidebar from "./DecisionAgendaSidebar";
import { getIssuesStatesAction } from "../../actions/issues.action";
import AgendaDecision from "./AgendaDecision";
import { toast } from "react-toastify";
import { InnerLoader, LoaderPage } from "../../component/Loader";
import { DisplayContent } from "../displayContent";
import {
  OrganizationTemplate,
  MultipleTags,
  ReadMore,
  PreNode
} from "../reusableComponent";
import { PopUp } from "../popUp";
import { Link } from "react-router-dom";
import { UploadAttachmentsWithTitleComponent } from "./downloadAttachements";
import { DisplayAttachments } from "../reusableComponent";
import {
  getDistrictAndDepartmentIssues,
  getDistrictList
} from "../../actions/common.action";
import { ChildIssuePopUp } from "./childIssuePopUp";
import {
  successToastStyle,
  errorToastStyle,
  infoToastStyle
} from "../../customToast";
import { getGroupByCategoryAndParentId } from "../../actions/createProject.action";
import { DisplayHtmlContent } from "../displayHtmlContent";
import { ReadMoreContent } from "../reusableComponent/readMore/readMoreContent";
const ADDED = "ADDED";
const resolvedIssueStatusId = "974";
const rejectedIssueStatusId = "958";
let previousIssueStatusId = "";
let previousAssigneeGroup = "";
const defaultListParams = {
  limit: 10,
  offset: 0,
  sortBy: "CREATED_DATE",
  sortOrder: "DESC"
};
class AddDecision extends Component {
  isDistrictDapartmentLoaded = false;
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      decisionStatus: null,
      description: null,
      id: 0,
      issueId: 0,
      issueStatus: null,
      statusId: null,
      meetingId: 0,
      taskCompletionDate: null,
      issueStatusArr: [],
      guestListItem: [],
      agendaDataList: [],
      files: [],
      issueListParams: { ...defaultListParams },
      checkAgenda: false,
      task1: null,
      task2: null,
      task1CompletionDate: null,
      task2CompletionDate: null,
      groupList: [{}],
      issueCOList: [{}],
      CENTRAL: [],
      STATE: [],
      secondaryDepartmentStateList: [],
      secondaryStateId: null,
      secondaryStateDepartmentId: null,
      secondaryMinistryId: null,
      secondaryMinistryDepartmentId: null,
      stateMinistry: false,
      MinistryState: false,
      secondaryRecipientGroupId: null,
      districtDeptCase: true
      // disabledSecondary: false
    };
  }

  componentDidMount() {
    const param = {};
    const { issues } = this.props;
    if (get(issues, "secondaryMinistryId")) {
      // this.setState({ disabledSecondary: true });
      this.getSecondaryDistrictDepartment(get(issues, "secondaryMinistryId"));
    } else {
      // this.setState({ disabledSecondary: true });
      this.getSecondaryDistrictDepartment(get(issues, "secondaryStateId"));
    }
    if (get(issues, "secondaryRecipientGroupId")) {
      const passedParam =
        get(issues, "recipientGroupCategory") == "DISTRICT"
          ? "STATE_DEPARTMENT"
          : "DISTRICT";
      this._getGroupByCategoryAndParentId([passedParam]);
      get(issues, "recipientGroupCategory") == "DISTRICT"
        ? this.setState({ districtDeptCase: true })
        : this.setState({ districtDeptCase: false });
    }
    let key;
    if (get(issues, "recipientGroupCategory") == "STATE") {
      param["category"] = ["CENTRAL"];
      key = "CENTRAL";
      this.getGroupCategory(key, param);
    }
    if (get(issues, "recipientGroupCategory") == "CENTRAL") {
      param["category"] = ["STATE"];
      key = "STATE";
      this.getGroupCategory(key, param);
    }
  }
  onBlur = value => {};
  _getGroupByCategoryAndParentId = async value => {
    const { issues, getGroupByCategoryAndParentId } = this.props;
    const param = {
      category: isValidArray(value) && value[0],
      parentId:
        get(issues, "recipientGroupParentId") ||
        get(issues, "project.sponsoredByid")
    };

    this.setState({ isGroupLoading: STATUS.LOADING });
    const response = await getGroupByCategoryAndParentId(undefined, param);
    if (response) {
      const { data, status, message } = response;
      !status &&
        toast.error(
          <p className="toast-text-alignment">
            {message}Issue In Fetching Data
          </p>,
          errorToastStyle
        );
      if (status) {
        this.setState({
          [value]: data,
          isGroupLoading: STATUS.SUCCESS
        });
      }
    } else {
      toast(ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR);
      this.setState({ isGroupLoading: STATUS.SUCCESS });
    }
  };

  getGroupCategory = async (key, param) => {
    const { getGroupCategoryIdDispatch } = this.props;
    const response = await getGroupCategoryIdDispatch(undefined, param);
    if (response) {
      const { data, status, message } = response;

      if (status) {
        if (key == "STATE") {
          this.setState({ CENTRAL: data });
        }
        this.setState({
          [key]: data
        });
      }
    }
  };

  async componentWillMount() {
    const {
      issues,
      project,
      agendaData,
      meetingData: meetingDecision,
      getIssuesStatesDispatch,
      getMinistryListDispatch,
      callFromIssueAction = false
    } = this.props;
    this.setState({
      decisionStatus: get(meetingDecision, "decisionStatus", null),
      description: get(meetingDecision, "meetingDescription", null),
      id: get(meetingDecision, "id", null),
      issueId: get(issues, "id", null),
      meetingId: get(agendaData, "id", null),
      taskCompletionDate: get(meetingDecision, "taskCompletionDate", null),
      isEditMode: get(issues, "meetingDecisionDTOS[0]", []).length,
      files: get(meetingDecision, "fileDTOList", []),
      districtDept: get(issues, "districtDeptId"),
      error: {
        description: { error: false },
        issueStatus: { error: false }
      },
      agenda: get(agendaData, "id", null),
      task1: get(meetingDecision, "task1", null),
      task1CompletionDate: get(meetingDecision, "task1CompletionDate", null),
      task2: get(meetingDecision, "task2", null),
      task2CompletionDate: get(meetingDecision, "task2CompletionDate", null),
      secondaryStateId: get(issues, "secondaryStateId", null),
      secondaryStateDepartmentId: get(
        issues,
        "secondaryStateDepartmentId",
        null
      ),
      secondaryMinistryId: get(issues, "secondaryMinistryId", null),
      secondaryMinistryDepartmentId: get(
        issues,
        "secondaryMinistryDepartmentId",
        null
      ),
      secondaryRecipientGroupId: get(issues, "secondaryRecipientGroupId", null)
    });
    this.getGuestList(issues && issues.projectId);
    const promise = [
      await getMinistryListDispatch(
        undefined,
        get(issues, "projectId", null) || get(issues, "project.id")
      ),
      await getIssuesStatesDispatch(undefined, {
        issueId: get(issues, "id", null),
        withoutMeeting:
          callFromIssueAction &&
          (get(issues, "issueStatus", null) === "RESOLVED" ||
            get(issues, "status", null) === "Resolved")
      })
    ];
    Promise.all(promise).then(data => {
      const ministryListResp = data[0];
      const issuesListResp = data[1];
      if (ministryListResp) {
        if (get(ministryListResp, "status")) {
          if (isValidArray(get(ministryListResp, "data"))) {
            const ministryId = get(ministryListResp, "data", []).find(value => {
              if (
                issues.status === "Under PMG Decision" ||
                issues.issueStatusName === "Under PMG Decision"
              ) {
                return value.name === "Project Monitoring Group";
              } else {
                return issues.status === "Pending with RM/RS" ||
                  issues.status === "Pending with RD" ||
                  issues.issueStatusName === "Pending with RM/RS" ||
                  issues.issueStatusName === "Pending with RD"
                  ? get(issues, "recipientGroup") === get(value, "name") ||
                      get(issues, "recipientState") === get(value, "name")
                  : get(issues, "assigneeGroup") === get(value, "name");
              }
            });
            previousAssigneeGroup = (ministryId && ministryId.id) || null;
            //
            const sponsoredByid =
              get(issues, "projectIssueDTO.sponsoredByid") ||
              get(project, "sponsoredByid") ||
              get(issues, "sponsoredById");
            const workflowType =
              get(project, "workflowType") ||
              get(issues, "projectIssueDTO.workflowType") ||
              get(issues, "workflowType");
            if (workflowType === "STATE") {
              if (
                get(issues, "status", "").toLowerCase() ===
                  "under central pmg" ||
                get(issues, "issueStatusName", "").toLowerCase() ===
                  "under central pmg"
              ) {
                this.getDistrcitDepartment(ministryId && ministryId.id);
              } else {
                this.getDistrcitDepartment(sponsoredByid);
              }
            } else {
              this.getDistrcitDepartment(ministryId && ministryId.id);
            }

            this.setState({
              ministryList:
                workflowType === "CENTRAL" ? get(ministryListResp, "data") : [],
              ministry: ministryId ? ministryId.id : null,
              showLoader: false,
              secondaryMinistryStateList:
                workflowType === "CENTRAL" ? get(ministryListResp, "data") : []
            });
          }
        } else {
          toast.error(
            <p className="toast-text-alignment">Ministry List not found</p>,
            errorToastStyle
          );
          this.setState({
            showLoader: false
          });
        }
      }

      if (issuesListResp) {
        if (get(issuesListResp, "status")) {
          let issueStatusId = null;
          get(issuesListResp, "data", []).forEach(issue => {
            (get(issue, "name") === get(issues, "status") ||
              get(issue, "name") === get(issues, "issueStatusName")) &&
              (issueStatusId = get(issue, "id"));
          });
          previousIssueStatusId = issueStatusId;
          this.setState({
            issuesList: get(issuesListResp, "data"),
            issueStatus: issueStatusId
          });
        }
      }
    });
  }
  getGuestList = async id => {
    let response = await getGuestList(undefined, [id]);
    this.setState({
      guestListItem: (response && response.data) || []
    });
  };

  onChange = (value, key, ele, nameText) => {
    const { getMinistryListDispatch, project, issues } = this.props;
    const { issuesList, ministryList } = this.state;
    const sponsoredByid =
      get(issues, "projectIssueDTO.sponsoredByid") ||
      get(project, "sponsoredByid") ||
      get(issues, "sponsoredById");
    const workflowType =
      get(project, "workflowType") ||
      get(issues, "projectIssueDTO.workflowType") ||
      get(issues, "workflowType");

    this.setState(
      prevState => {
        let params = {};
        if (key === "ministry") {
          params["districtDept"] = null;
          params["STATE_DEPARTMENT"] = "";
          params["DISTRICT"] = "";
          params["secondaryRecipientGroupId"] = null;
          if (value < 1200) {
            this.setState({ districtDeptCase: true });
          } else this.setState({ districtDeptCase: false });

          if (
            nameText == "Ministry" ||
            nameText == "Department" ||
            nameText == "MAHSR" ||
            nameText == "Prime" ||
            nameText == "Niti" ||
            nameText == "State"
          ) {
            this.setState({ stateMinistry: true, MinistryState: false });
            this.state.CENTRAL.find(data => {
              if (data.id == parseInt(value)) {
                // this.setState({ disabledSecondary: false });
                params["secondaryMinistryId"] = null;
                params["secondaryMinistryDepartmentId"] = null;
                params["CENTRAL"] = [];
                params["secondaryDepartmentStateList"] = null;
                params["secondaryStateId"] = null;
                params["secondaryStateDepartmentId"] = null;
                params["secondaryDepartmentStateList"] = null;
                return true;
              }
            });
          } else {
            this.setState({ stateMinistry: false, MinistryState: true });
            this.state.CENTRAL.find(data => {
              if (data.id == parseInt(value)) {
                // this.setState({ disabledSecondary: false });
                params["secondaryMinistryId"] = null;
                params["secondaryMinistryDepartmentId"] = null;
                params["CENTRAL"] = [];
                params["secondaryDepartmentStateList"] = null;
                params["secondaryStateId"] = null;
                params["secondaryStateDepartmentId"] = null;
                params["secondaryDepartmentStateList"] = null;
                return true;
              }
            });
          }
        }

        if (key == "secondaryRecipientGroup") {
          params["secondaryRecipientGroupId"] = null;
        }

        if (key === "issueStatus") {
          const { issues } = this.props;
          const isIssuestatus = issues.issueStatusName == "Resolved";
          if (value === "968" || value === "955") {
            params["ministry"] = "207";
          } else if (
            value === "958" ||
            value === "974" ||
            value === "977" ||
            (value === "963" && isIssuestatus)
          ) {
            params["ministry"] = get(issues, "recipientGroupId");
          } else if (value === "981") {
            let statePmgData =
              ministryList &&
              ministryList.length &&
              ministryList.find(item => item.name.endsWith("PMG"));
            params["ministry"] = statePmgData && statePmgData.id;
          } else if (value === "954") {
            params["ministry"] = sponsoredByid;
          } else {
            params["ministry"] = "";
          }
        }

        if (key === "secondaryStateId") {
          params["secondaryStateDepartmentId"] = "";
        }

        if (key === "secondaryMinistryId") {
          params["secondaryMinistryDepartmentId"] = "";
        }

        return {
          [key]: value,
          ...params
        };
      },
      async () => {
        if (key === "issueStatus" && workflowType === "STATE") {
          const status = issuesList.find(val => val.id === +value);
          if (status && status.name.toLowerCase() === "under central pmg") {
            const resp = await getMinistryListDispatch(undefined, value);
            this.setState({
              ministryList: (resp && resp.data) || []
            });
          } else {
            this.getDistrcitDepartment(sponsoredByid);
          }
        }

        let args = {};
        let stateValue = "";

        if (key === "ministry" && workflowType === "CENTRAL") {
          this.getDistrcitDepartment(value);
          // get child issues
        }

        if (
          key === "ministry" &&
          get(issues, "recipientGroupCategory") == "CENTRAL"
        ) {
          args["category"] = ["STATE"];
          stateValue = "STATE";
          this.getGroupCategory(stateValue, args);
        }

        if (
          key === "ministry" &&
          get(issues, "recipientGroupCategory") == "STATE"
        ) {
          if (!this.state.stateMinistry) {
            args["category"] = ["CENTRAL"];
            stateValue = "CENTRAL";
            this.getGroupCategory(stateValue, args);
          } else {
            args["category"] = ["STATE"];
            stateValue = "STATE";
            this.getGroupCategory(stateValue, args);
          }
        }

        if (
          key === "ministry" &&
          get(issues, "recipientGroupCategory") == "CENTRAL"
        ) {
          if (!this.state.MinistryState) {
            args["category"] = ["STATE"];
            stateValue = "STATE";
            this.getGroupCategory(stateValue, args);
          } else {
            args["category"] = ["CENTRAL"];
            stateValue = "CENTRAL";
            this.getGroupCategory(stateValue, args);
          }
        }

        if (
          key === "ministry" &&
          get(issues, "recipientGroupCategory") == "DISTRICT"
        ) {
          if (value < 1200) {
            this._getGroupByCategoryAndParentId(["STATE_DEPARTMENT"]);
          } else this._getGroupByCategoryAndParentId(["DISTRICT"]);
        } else if (
          key === "ministry" &&
          get(issues, "recipientGroupCategory") == "STATE_DEPARTMENT"
        ) {
          if (value < 1200) {
            this._getGroupByCategoryAndParentId(["STATE_DEPARTMENT"]);
          } else this._getGroupByCategoryAndParentId(["DISTRICT"]);
        }

        if (key === "secondaryMinistryId") {
          this.getSecondaryDistrictDepartment(value);
        }

        if (key === "secondaryStateId") {
          this.getSecondaryDistrictDepartment(value);
        }
      }
    );
  };

  onError = (value, key) => {
    this.setState(prevState => ({
      error: {
        ...prevState.error,
        [key]: value
      }
    }));
  };

  onSubmit = status => {
    const {
      addDecisionDispatch,
      handleClose,
      handleUpdateStatus,
      callApiOnSuccess
    } = this.props;

    const {
      description,
      issueStatus,
      ministry,
      task1,
      task2,
      task1CompletionDate,
      task2CompletionDate,
      secondaryStateId,
      secondaryStateDepartmentId,
      secondaryMinistryId,
      secondaryMinistryDepartmentId
    } = this.state;
    let isValid = true;

    if (
      (task1 && !task1CompletionDate) ||
      (task2 && !task2CompletionDate) ||
      (!task1 && task1CompletionDate) ||
      (!task2 && task2CompletionDate) ||
      !description ||
      !issueStatus ||
      !ministry
    ) {
      isValid = false;
    }

    if (isValid) {
      this.setState({ showLoader: true }, async () => {
        const response = await addDecisionDispatch(
          undefined,
          modifyDataForIssueListPost({
            ...this.state,
            decisionStatus: status,
            assigneeGroupId: ministry,
            meetingId: this.state.agenda
          })
        );
        if (response) {
          this.setState({ showLoader: false });
          const { message, status } = response;
          if (status) {
            toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            );
            handleClose();
            typeof handleUpdateStatus === "function" && handleUpdateStatus();
            isFunction(callApiOnSuccess) && callApiOnSuccess();
          } else {
            toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
          }
        }
      });
    } else {
      this.setState(prevState => ({
        error: {
          ...prevState.error,
          description: {
            error: !description,
            message: !description && ERROR_MSG.DEFAULT_MSG
          },
          issueStatus: {
            error: !issueStatus,
            message: !issueStatus && ERROR_MSG.DEFAULT_MSG
          },
          ministry: {
            error: !ministry,
            message: !ministry && ERROR_MSG.DEFAULT_MSG
          }
        },
        showLoader: false
      }));
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
        errorToastStyle
      );
    }
  };

  saveAddDraftDecision = () => {
    const {
      addDecisionDispatch,
      handleClose,
      handleUpdateStatus,
      callApiOnSuccess
    } = this.props;
    const { description } = this.state;
    this.setState({ showLoader: true }, async () => {
      if (description) {
        const response = await addDecisionDispatch(
          undefined,
          modifyDataForIssueListPost({ ...this.state, decisionStatus: "DRAFT" })
        );
        if (response && response.status) {
          this.setState({ showLoader: false });
          const { message } = response;
          toast.success(
            <p className="toast-text-alignment">{message}</p>,
            successToastStyle
          );
          handleClose();
          typeof handleUpdateStatus === "function" && handleUpdateStatus();
          typeof callApiOnSuccess === "function" && callApiOnSuccess();
        } else {
          this.setState({ showLoader: false });
          toast.error(
            <p className="toast-text-alignment">{response.message}</p>,
            errorToastStyle
          );
        }
      } else {
        this.setState(prevState => ({
          error: {
            ...prevState.error,
            description: {
              error: !description,
              message: !description && ERROR_MSG.DEFAULT_MSG
            }
          },
          showLoader: !prevState.showLoader
        }));
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
          errorToastStyle
        );
      }
    });
  };

  setMeetingType = type => {
    const { issues } = this.props;
    if (type) {
      this.getAgendaForIssueAction(issues.id);
      this.setState({
        withMeeting: type
      });
    } else {
      this.setState({
        withMeeting: false
      });
    }
  };
  //Get agenda list for with meeting status
  getAgendaForIssueAction = async id => {
    this.setState({ showLoader: true });
    const response = await getAgendaIssueAction(
      undefined,
      id,
      this.state.checkAgenda
    );
    if (response) {
      this.setState({ showLoader: false });
      const { status, data, message } = response;
      if (status && data) {
        !isValidArray(data.data)
          ? toast.info(
              <p className="toast-text-alignment">{data.message || ""}</p>,
              infoToastStyle
            ) &&
            this.setState({
              withMeeting: false,
              message: data
            })
          : this.setState({
              agendaDataList: data.data
            });
      } else {
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
        this.setState({
          withMeeting: false
        });
      }
    } else {
      this.setState({ showLoader: false });
      toast.error(
        <p className="toast-text-alignment">
          {ERROR_MSG.DEFAULT_MSG_FOR_REPONSE_ERROR}
        </p>,
        errorToastStyle
      );
    }
  };

  onChangeAgenda = (value, key) => {
    let { issues } = this.props;
    let { issuesList } = this.state;
    let _selectedAgenda =
      isValidArray(get(issues, "meetingDecisionDTOS")) &&
      get(issues, "meetingDecisionDTOS").find(
        item => item.meetingId === +value
      );
    const status = issuesList.find(
      val => val.name === (_selectedAgenda && _selectedAgenda.issueStatus)
    );
    this.setState({
      [key]: value,
      id: _selectedAgenda && _selectedAgenda.id,
      taskCompletionDate: _selectedAgenda && _selectedAgenda.taskCompletionDate,
      files: (_selectedAgenda && _selectedAgenda.fileDTOList) || [],
      task1: _selectedAgenda && _selectedAgenda.task1,
      task1CompletionDate:
        _selectedAgenda && _selectedAgenda.task1CompletionDate,
      task2: _selectedAgenda && _selectedAgenda.task2,
      task2CompletionDate:
        _selectedAgenda && _selectedAgenda.task2CompletionDate
    });
    if (_selectedAgenda && _selectedAgenda.meetingDescription) {
      this.setState({
        description: _selectedAgenda && _selectedAgenda.meetingDescription
      });
    }
    if (_selectedAgenda && _selectedAgenda.decisionStatus !== "DRAFT") {
      this.setState({
        issueStatus: status && status.id
      });
    }
  };

  onToggleModalPopUp = () => {
    this.setState(prevState => ({
      displayPopUp: !prevState.displayPopUp
    }));
  };

  onToggleAttachment = file => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay,
        files: file ? [file, ...prevState.files] : prevState.files
      };
    });
  };

  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(value => value.id !== id),
        toggleAttachementDisplay: false
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  getChildIssues = id => {
    const { ministry } = this.state;
    this.setState(
      {
        districtId: true
      },
      async () => {
        const {
          props: { issues }
        } = this;
        const response = await getChildIssuesAction(
          undefined,
          issues && issues.id
        );
        const { data } = response;
        this.setState(
          {
            childIssues: data,
            childIssuesPopUpShow:
              ministry !== previousAssigneeGroup &&
              isValidArray(data) &&
              +ministry !== get(issues, "recipientGroupId")
          },
          () => {
            const { ministry, issueStatus } = this.state;
            if (
              !isValidArray(data) ||
              (isValidArray(data) && ministry === previousAssigneeGroup)
            ) {
              if (
                previousIssueStatusId === resolvedIssueStatusId ||
                (previousAssigneeGroup === ministry &&
                  previousIssueStatusId === issueStatus)
              ) {
                this.onSubmit(ADDED);
              } else {
                this.onToggleModalPopUp();
              }
            } else if (
              !(
                ministry !== previousAssigneeGroup &&
                isValidArray(data) &&
                +ministry !== get(issues, "recipientGroupId")
              )
            ) {
              this.onToggleModalPopUp();
            }
          }
        );
      }
    );
  };

  getSecondaryDistrictDepartment = id => {
    const { project, issues } = this.props;

    const workflowType =
      get(project, "workflowType") ||
      get(issues, "projectIssueDTO.workflowType") ||
      get(issues, "workflowType");

    this.setState(
      {
        secondaryDepartmentStateList: null
      },
      async () => {
        if (
          get(issues, "secondaryMinistryId") ||
          get(issues, "secondaryStateId")
        ) {
          if (get(issues, "secondaryMinistryId")) {
            const response = getDistrictAndDepartmentIssues(
              undefined,
              id,
              false,
              true
            );
            response.then(data => {
              this.setState({ secondaryDepartmentStateList: data.data.data });
            });
          } else {
            const response = getDistrictAndDepartmentIssues(
              undefined,
              id,
              false,
              true
            );
            response.then(data => {
              this.setState({ secondaryDepartmentStateList: data.data.data });
            });
          }
        }
        // let params = {
        //   districtDepartment: status ? data.data : null
        // };
        // if (workflowType === "STATE" && !this.isDistrictDapartmentLoaded) {
        //   this.isDistrictDapartmentLoaded = true;
        //   const ministry = get(data, "data", []).find(value => {
        //     return issues.status === "Pending with RM/RS" ||
        //       issues.status === "Pending with RD"
        //       ? get(issues, "recipientGroup") === get(value, "name") ||
        //           get(issues, "recipientState") === get(value, "name")
        //       : get(issues, "assigneeGroup") === get(value, "name");
        //   });
        //   previousAssigneeGroup = ministry ? ministry.id : ministry;
        //   params = {
        //     ministryList: status ? data.data : null,
        //     ministry: (ministry && ministry.id) || null,
        //   };
        // }
        // this.setState({
        //   ...params
        // });
        // if (workflowType !== "CENTRAL") {
        //   this.setState({
        //     ministryList: status ? data.data : null,
        //   });
        // }
      }
    );
  };

  getDistrcitDepartment = id => {
    // setting districtId if fresh call is coming with diffrent ids
    // and set it to null after response
    const { project, issues } = this.props;

    const workflowType =
      get(project, "workflowType") ||
      get(issues, "projectIssueDTO.workflowType") ||
      get(issues, "workflowType");

    this.setState(
      {
        districtDepartment: null
      },
      async () => {
        const response = await getDistrictAndDepartmentIssues(
          undefined,
          id,
          workflowType === "STATE",
          true
        );
        const { data, status } = response || {};
        let params = {
          districtDepartment: status ? data.data : null
        };
        if (workflowType === "STATE" && !this.isDistrictDapartmentLoaded) {
          this.isDistrictDapartmentLoaded = true;
          const ministry = get(data, "data", []).find(value => {
            return issues.status === "Pending with RM/RS" ||
              issues.status === "Pending with RD"
              ? get(issues, "recipientGroup") === get(value, "name") ||
                  get(issues, "recipientState") === get(value, "name")
              : get(issues, "assigneeGroup") === get(value, "name");
          });
          previousAssigneeGroup = ministry ? ministry.id : ministry;
          params = {
            ministryList: status ? data.data : null,
            ministry: (ministry && ministry.id) || null
          };
        }
        this.setState({
          ...params
        });
        if (workflowType !== "CENTRAL") {
          this.setState({
            ministryList: status ? data.data : null
          });
        }
      }
    );
  };

  onChildIssuePopUp = () => {
    const {
      state: { issueStatus, ministry }
    } = this;
    if (ministry !== "207" && issueStatus === "963") {
      this.getChildIssues(ministry);
    } else {
      if (
        previousIssueStatusId === resolvedIssueStatusId ||
        (previousAssigneeGroup === ministry &&
          previousIssueStatusId === issueStatus)
      ) {
        this.onSubmit(ADDED);
      } else {
        this.onToggleModalPopUp();
      }
    }
  };

  onToogleChildIssuePopUp = () => {
    this.setState({
      childIssuesPopUpShow: false
    });
  };

  onToggleAttachment = file => {
    this.setState(prevState => {
      return {
        toggleAttachementDisplay: !prevState.toggleAttachementDisplay,
        files: file ? [file, ...prevState.files] : prevState.files
      };
    });
  };

  onRemoveFile = ({ id }) => {
    try {
      this.setState(prevState => ({
        files: prevState.files.filter(value => value.id !== id),
        toggleAttachementDisplay: false
      }));
    } catch (error) {
      console.log(`Error while deleting the image ${error.message}`);
    }
  };

  render() {
    const {
      onToggleModalPopUp,
      onToggleAttachment,
      onRemoveFile,
      onToogleChildIssuePopUp
    } = this;
    const {
      show,
      handleClose,
      issues,
      agendaData,
      issueListStatus,
      viewMoreStatus,
      title,
      project,
      redirectToAgenda,
      showSaveAsDraft = true,
      agendasAssociatedWithIssue
    } = this.props;
    const {
      description,
      issueStatus,
      taskCompletionDate,
      withMeeting,
      error,
      agenda,
      ministry,
      files,
      showLoader,
      agendaDataList,
      ministryList,
      secondaryMinistryStateList,
      secondaryDepartmentStateList,
      issuesList,
      displayPopUp,
      districtDept,
      districtDepartment,
      childIssues,
      childIssuesPopUpShow,
      toggleAttachementDisplay,
      task1,
      task2,
      task1CompletionDate,
      task2CompletionDate,
      secondaryMinistryId,
      secondaryStateId,
      secondaryMinistryDepartmentId,
      secondaryStateDepartmentId,
      secondaryRecipientGroupId,
      STATE_DEPARTMENT,
      DISTRICT,
      isGroupLoading
    } = this.state;
    const groupCategory = getLocalstorage("groupCategory");
    const isEditMode = title === "Edit";
    const projectPPList = get(project, "projectPPList", []);
    const secondaryStateDeptDistrict = STATE_DEPARTMENT || DISTRICT;

    return (
      <React.Fragment>
        <LoaderPage loading={showLoader} />
        <ChildIssuePopUp
          show={childIssuesPopUpShow}
          childIssues={childIssues}
          onClose={onToogleChildIssuePopUp}
        />
        {toggleAttachementDisplay ? (
          <UploadAttachmentsWithTitleComponent
            displayModal={toggleAttachementDisplay}
            onCloseModal={onToggleAttachment}
            fileFormats={DOCUMENT_FORMATS}
          />
        ) : null}
        {displayPopUp ? (
          <PopUp
            containerClass="add-decision-modal"
            saveBtnText="Yes"
            closeBtnText="No"
            onSave={() => {
              this.onSubmit(ADDED);
            }}
            onClose={onToggleModalPopUp}
            content={
              issueStatus === resolvedIssueStatusId ? (
                <>
                  <div>
                    Marking the issue Resolved will also resolve it's child
                    issue(s).
                  </div>
                  <div>Once Resolved, status can't be reversed.</div>
                  <div>Are you sure you want to do this?</div>
                </>
              ) : issueStatus === rejectedIssueStatusId ? (
                <>
                  <div>
                    Marking the issue Rejected will also reject it's child
                    issue(s). Once Rejected, status can't be reversed.
                  </div>
                  <div>Are you sure you want to do this?</div>
                </>
              ) : (
                <>
                  <div>
                    Adding decision will update the assignee/recipient and
                    status of the issue.
                  </div>
                  <div>Are you sure you want to do this?</div>
                </>
              )
            }
          />
        ) : null}
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="modal-select-issue"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {viewMoreStatus ? "View" : title || "Add"} Decision
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-0">
            <div className="issue-list-content add-decision-project mx-36px pt-40px">
              <div className="issue-list-multiple add-decision-issue">
                <div className="select-issue-list-wrapper add-decision-wrapper">
                  <div className="decision-project-overview">
                    <div className="project-no">
                      <div>
                        Project
                        <span className="project-id">
                          <Link
                            to={{
                              pathname: PATHS.PROJECT_DETAILS,
                              search: `?projectId=${get(issues, "projectId")}`
                            }}
                          >
                            #{get(project, "displayId", null)}
                          </Link>
                        </span>
                        {projectPPList &&
                          projectPPList.map(item => {
                            if (item.organizationGroup) {
                              return (
                                <OrganizationTemplate
                                  title={item.organizationGroup}
                                  classes="organisation-name"
                                />
                              );
                            }
                          })}
                      </div>
                    </div>
                    <div id="agenda-detail-issue-list">
                      <MultipleTags
                        containerClass="select-issue-single-stages"
                        options={[
                          {
                            title: get(
                              project,
                              "projectStatusWithRespectToIssueStatus"
                            ),
                            classes: getColor(
                              get(
                                project,
                                "projectStatusWithRespectToIssueStatus"
                              )
                            )
                          },
                          {
                            title:
                              get(project, "projectCompletionDTO.status") !==
                              "NO IMPLEMENTATION"
                                ? get(project, "projectCompletionDTO.status")
                                : "",
                            classes:
                              get(project, "projectCompletionDTO.status") !==
                              "NO IMPLEMENTATION"
                                ? getColor(
                                    get(project, "projectCompletionDTO.status")
                                  )
                                : ""
                          }
                        ]}
                      />
                    </div>
                    <h2 className="project-heading">
                      <span
                        className={`${
                          /[\u0900-\u097F]/.test(get(project, "name"))
                            ? "hindi-text-wrap"
                            : ""
                        }`}
                      >
                        {get(project, "name", "NA")}
                      </span>
                    </h2>
                    <div className="sponsor">
                      Sponsored by -{" "}
                      <span className="sponsor-desc decision-sponsor-issue">
                        {get(project, "sponsoredBy", null)}
                      </span>
                      <span className="seperator">|</span>
                      Issue(s) Open -{" "}
                      <span className="sponsor-desc decision-sponsor-issue">
                        {get(project, "openIssuesCount", 0)}
                      </span>
                      <span className="seperator">|</span>
                      Issue(s) Resolved -{" "}
                      <span className="sponsor-desc decision-sponsor-issue">
                        {get(project, "resolvedIssuesCount", 0)}
                      </span>
                    </div>
                  </div>
                  <div className="add-decision-cost">
                    <div className="cost-heading">Project Cost</div>
                    <div className="cost">
                      ₹{" "}
                      {get(project, "totalCost")
                        ? formatNumber(
                            get(project, "revisedCost", 0) ||
                              get(project, "totalCost")
                          )
                        : formatNumber(
                            get(project, "revisedCost", 0) ||
                              get(project, "cost", 0)
                          )}{" "}
                      Cr.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="select-issue-content decision-issue-content decision-issue px-36px">
              <div className="issue-list-top">
                <div className="issue-list-header">
                  <span
                    className={`issue-number ${
                      get(issues, "duplicate") ? "duplicate-issue-number" : ""
                    }`}
                  >
                    {get(issues, "duplicate") ? "Duplicate Issue" : "Issue"}{" "}
                    <b>
                      <Link
                        to={{
                          pathname: PATHS.ISSUE_DETAIL,
                          search: `?issueId=${get(
                            issues,
                            "id"
                          )}&&projectId=${get(issues, "projectId")}`
                        }}
                      >
                        #{get(project, "displayId", null)}-
                        {get(issues, "id", null)}
                      </Link>
                    </b>
                  </span>
                  <h2
                    className={`issue-title ${
                      /[\u0900-\u097F]/.test(get(issues, "title"))
                        ? "hindi-text-wrap-comment"
                        : ""
                    }`}
                  >
                    {get(issues, "title", null)}
                  </h2>
                </div>
                <div className="issue-list-status">
                  <div className="issue-list-status-inner">
                    <div className="issue-assignee">
                      Assigned to <b>{get(issues, "assigneeGroup", "NA")}</b>
                    </div>
                    <div className="issue-assign-date">
                      <Image src={IconTime} alt="Time" />
                      <span>{dayAgo(get(issues, "createdDate"))}</span>
                    </div>
                  </div>
                  <Button
                    className={`btn-extra-small animated flipInX ${getColor(
                      get(issues, "issueStatusName", null) ||
                        get(issues, "status", null)
                    )} unClickable`}
                  >
                    {get(issues, "issueStatusName", null) ||
                      get(issues, "status", null)}
                  </Button>
                </div>
              </div>
              <div className="issue-list-middle">
                <div className="issue-list-desc-wrapper">
                  <span className="issue-recipient">
                    <span className="issue-recipient-title">
                      Recipient{" "}
                      {transformProjectCategoryId(
                        get(issues, "recipientGroupCategory")
                      )}{" "}
                      -{" "}
                    </span>
                    {get(issues, "recipientState") ||
                      get(issues, "recipientGroup") ||
                      "NA"}
                  </span>
                  {get(issues, "districtName") ? (
                    <span className="issue-recipient">
                      <span className="issue-recipient-title">
                        District/Department -{" "}
                      </span>
                      {get(issues, "districtName")}
                    </span>
                  ) : null}
                  <p className="issue-category">
                    <span className="issue-category-title">
                      Issue Category -{" "}
                    </span>
                    {get(issues, "category", null) ||
                      get(issues, "issueCategory", null)}
                  </p>
                  {get(issues, "subCategory") ||
                  get(issues, "issueSubCategory") ? (
                    <p className="issue-sub-category">
                      <span className="issue-category-title">
                        Issue Sub-Category -{" "}
                      </span>
                      {get(issues, "subCategory", null) ||
                        get(issues, "issueSubCategory", null)}
                    </p>
                  ) : null}
                  {!showLoader ? (
                    <div className="issue-list-desc">
                      <PreNode>
                        {/* <ReadMore
                          clamp={3}
                          content={get(issues, "description")}
                        /> */}
                        <ReadMoreContent
                          clamp={3}
                          content={get(issues, "description")}
                        />
                      </PreNode>
                    </div>
                  ) : (
                    false
                  )}

                  <div className="decision-created-on">
                    {get(issues, "creatorName") ||
                      get(issues, "issueCreatorName") ||
                      "NA"}{" "}
                    |{" "}
                    <span>
                      {get(issues, "verificationDate")
                        ? `Verified on
                            ${dateFormat(get(issues, "verificationDate", null))}
                          `
                        : `
                          Created on
                          ${dateFormat(get(issues, "createdDate", null))}
                          `}
                    </span>
                  </div>
                </div>
              </div>
              {(get(issues, "latestIssueComments") && (
                <div style={{ paddingBottom: "15px" }}>
                  <div className="comment-heading">
                    <h3>Latest Comment</h3>
                  </div>
                  {/* <DisplayContent
                    classes={"issue-list-desc"}
                    content={get(issues, "latestIssueComments")}
                  /> */}
                  <DisplayHtmlContent
                    classes={`issue-list-desc ${
                      get(issues, "latestIssueComments.comment").match(
                        /[\u0900-\u097F]/
                      )
                        ? "hindi-text-no-weight"
                        : ""
                    }`}
                    showCreatedInfo={false}
                    content={get(issues, "latestIssueComments")}
                  />
                </div>
              )) ||
                null}
            </div>
            {!viewMoreStatus && (
              <>
                <h3 className="add-decision-heading px-36px decision-add-heading">
                  Add Decision{" "}
                </h3>
                <div className="agenda-fields-container">
                  <div
                    className={`select-issue-wrapper issue-decision-wrapper agenda-fields ${
                      issueListStatus
                        ? "px-36px"
                        : "flex-row justify-content-between p-0 edit-decision-modal-container"
                    }`}
                  >
                    <span className="font-italic decision-agenda-notice">
                      {agendasAssociatedWithIssue !== undefined &&
                      agendasAssociatedWithIssue.length !== 0 ? (
                        <>
                          (The issue is already associated with following open
                          Agenda(s):&nbsp;
                        </>
                      ) : (
                        ""
                      )}
                      {(agendasAssociatedWithIssue || []).map(
                        (agenda, index) => (
                          <a href={"/agenda-details?agendaId=" + agenda.id}>
                            #{agenda.id} - {agenda.meetingName}
                            {index <= agendasAssociatedWithIssue.length - 2
                              ? ", "
                              : ""}
                          </a>
                        )
                      ) || "NA"}
                      {agendasAssociatedWithIssue !== undefined &&
                      agendasAssociatedWithIssue.length !== 0
                        ? ")"
                        : ""}
                    </span>
                    <DecisionAgendaSidebar
                      issueListStatus={issueListStatus}
                      onChangeAgenda={this.onChangeAgenda}
                      agenda={agenda}
                      agendaDataList={agendaDataList}
                      agendaDetail={agendaData}
                      params={{
                        setMeetingType: this.setMeetingType,
                        issueDetails: issues,
                        withMeeting
                      }}
                      agendaData={agendaData}
                      agendasAssociatedWithIssue={agendasAssociatedWithIssue}
                    />
                    <div className="select-issue-content add-decision-meeting w-full">
                      <Form.Group className="m-0">
                        <div className="decision-issue-status">
                          <Form.Group className="container-alignment field-select field-location m-0">
                            <div className="decision-form-input-container">
                              <Form.Label className="p-0">
                                Issue Status <span className="required">*</span>
                              </Form.Label>
                              <div className="added-location-wrapper">
                                <div className="added-location-detail action-items-select assign-to-target">
                                  <div className="location-name">
                                    <Field
                                      keyName="issueStatus"
                                      as="select"
                                      className="decision-select-field"
                                      onChange={this.onChange}
                                      onError={this.onError}
                                      value={issueStatus}
                                      onBlur={this.onBlur}
                                      isInvalid={get(
                                        error,
                                        "issueStatus.error"
                                      )}
                                      disabled={
                                        previousIssueStatusId ==
                                          resolvedIssueStatusId && isEditMode
                                      }
                                    >
                                      <option value="">
                                        {" "}
                                        - Select Status -
                                      </option>
                                      {(issuesList || []).map((value, idx) => (
                                        <option
                                          value={value.id}
                                          key={`${value.id}-${idx}`}
                                        >
                                          {value.name}
                                        </option>
                                      ))}
                                    </Field>
                                    <Form.Control.Feedback type="invalid">
                                      {get(error, "issueStatus.message")}
                                    </Form.Control.Feedback>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {(get(project, "workflowType") === "CENTRAL" ||
                              get(issues, "projectIssueDTO.workflowType") ===
                                "CENTRAL" ||
                              get(issues, "workflowType") === "CENTRAL") &&
                            groupCategory === "PMG" ? (
                              <div className="decision-form-input-container">
                                <Form.Group className="field-datepicker m-0">
                                  <Form.Label className="decision-meeting-label p-0">
                                    Issue Resolution Date
                                  </Form.Label>
                                  <div
                                    className="form-field meeting-date datepicker"
                                    style={{ marginTop: "7.5px" }}
                                  >
                                    <DatePicker
                                      isClearable={taskCompletionDate}
                                      selected={taskCompletionDate}
                                      disabled={
                                        previousIssueStatusId ===
                                          resolvedIssueStatusId && isEditMode
                                      }
                                      onChange={value => {
                                        this.onChange(
                                          value,
                                          "taskCompletionDate"
                                        );
                                        this.onError(
                                          value,
                                          "taskCompletionDate"
                                        );
                                      }}
                                    />
                                  </div>
                                </Form.Group>
                              </div>
                            ) : (
                              <div className="decision-form-input-container">
                                <Form.Label className="p-0">
                                  {issueStatus === "982"
                                    ? "Recipient"
                                    : "Assignee/Recipient"}
                                  <span className="required">*</span>
                                </Form.Label>
                                <div className="added-location-wrapper">
                                  <div className="added-location-detail action-items-select assign-to-target">
                                    <div className="location-name">
                                      <Field
                                        keyName="ministry"
                                        as="select"
                                        className="decision-select-field"
                                        onChange={this.onChange}
                                        onError={this.onError}
                                        value={ministry}
                                        onBlur={this.onBlur}
                                        isInvalid={get(error, "ministry.error")}
                                        disabled={
                                          (previousIssueStatusId ==
                                            resolvedIssueStatusId &&
                                            isEditMode) ||
                                          (issueStatus === "968" ||
                                            issueStatus === "955" ||
                                            issueStatus === "954" ||
                                            issueStatus === 968 ||
                                            issueStatus === 955 ||
                                            issueStatus === 954 ||
                                            issueStatus === "958" ||
                                            issueStatus === "974" ||
                                            issueStatus === "977" ||
                                            issueStatus === 958 ||
                                            issueStatus === 974 ||
                                            issueStatus === 977 ||
                                            issueStatus === "981" ||
                                            issueStatus === 981)
                                          // ||
                                          // (issueStatus === 963 &&
                                          //   !isIssuestatus) ||
                                          // (issueStatus === "963" &&
                                          //   !isIssuestatus)
                                        }
                                      >
                                        <option value="">
                                          {" "}
                                          -
                                          {groupCategory === "PMG"
                                            ? "Select Ministry/State"
                                            : issueStatus === "982"
                                            ? "Select Ministry/State"
                                            : "Select District/State-Department"}{" "}
                                          -
                                        </option>
                                        {isValidArray(ministryList) &&
                                          ministryList.map((value, idx) => (
                                            <option
                                              value={value.id}
                                              key={`${value.id}-${idx}`}
                                            >
                                              {value.name}
                                            </option>
                                          ))}
                                      </Field>
                                      <Form.Control.Feedback type="invalid">
                                        {get(error, "ministry.message")}
                                      </Form.Control.Feedback>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Form.Group>
                        </div>

                        {(get(project, "workflowType") === "CENTRAL" ||
                          get(issues, "projectIssueDTO.workflowType") ===
                            "CENTRAL" ||
                          get(issues, "workflowType") === "CENTRAL") &&
                        groupCategory === "PMG" ? (
                          <div className="decision-issue-status">
                            <Form.Group className="container-alignment field-select field-location m-0">
                              <div className="decision-form-input-container">
                                <Form.Label className="p-0">
                                  {issueStatus === "982"
                                    ? "Recipient"
                                    : "Assignee/Recipient"}
                                  <span className="required">*</span>
                                </Form.Label>
                                <div className="added-location-wrapper">
                                  <div className="added-location-detail action-items-select assign-to-target">
                                    <div className="location-name">
                                      <Field
                                        keyName="ministry"
                                        as="select"
                                        className="decision-select-field"
                                        onChange={this.onChange}
                                        onError={this.onError}
                                        value={ministry}
                                        onBlur={this.onBlur}
                                        isInvalid={get(error, "ministry.error")}
                                        disabled={
                                          (previousIssueStatusId ==
                                            resolvedIssueStatusId &&
                                            isEditMode) ||
                                          (issueStatus === "968" ||
                                            issueStatus === "955" ||
                                            issueStatus === "954" ||
                                            issueStatus === 968 ||
                                            issueStatus === 955 ||
                                            issueStatus === 954 ||
                                            issueStatus === "958" ||
                                            issueStatus === "974" ||
                                            issueStatus === "977" ||
                                            issueStatus === 958 ||
                                            issueStatus === 974 ||
                                            issueStatus === 977 ||
                                            issueStatus === "981" ||
                                            issueStatus === 981)
                                          //  ||
                                          // (issueStatus === 963 &&
                                          //   !isIssuestatus) ||
                                          // (issueStatus === "963" &&
                                          //   !isIssuestatus)
                                        }
                                      >
                                        <option value="">
                                          {" "}
                                          -
                                          {groupCategory === "PMG"
                                            ? "Select Ministry/State"
                                            : issueStatus === "982"
                                            ? "Select Ministry/State"
                                            : "Select District/State-Department"}{" "}
                                          -
                                        </option>
                                        {isValidArray(ministryList) &&
                                          ministryList.map((value, idx) => (
                                            <option
                                              value={value.id}
                                              key={`${value.id}-${idx}`}
                                            >
                                              {value.name}
                                            </option>
                                          ))}
                                      </Field>
                                      <Form.Control.Feedback type="invalid">
                                        {get(error, "ministry.message")}
                                      </Form.Control.Feedback>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="decision-form-input-container">
                                <Form.Label className="p-0">
                                  District/Department
                                </Form.Label>
                                <div
                                  className="added-location-wrapper"
                                  style={{ marginTop: "2.5px" }}
                                >
                                  <div className="added-location-detail action-items-select assign-to-target">
                                    <div className="location-name">
                                      <Field
                                        keyName="districtDept"
                                        as="select"
                                        className="decision-select-field"
                                        onChange={this.onChange}
                                        onError={this.onError}
                                        value={districtDept}
                                        onBlur={this.onBlur}
                                        disabled={
                                          !isValidArray(districtDepartment) ||
                                          (previousIssueStatusId ==
                                            resolvedIssueStatusId &&
                                            isEditMode)
                                        }
                                      >
                                        <option value="">
                                          - Select District/Department -
                                        </option>
                                        {isValidArray(districtDepartment) &&
                                          districtDepartment.map(
                                            (value, idx) => (
                                              <option
                                                value={value.id}
                                                key={`${value.id}-${idx}`}
                                              >
                                                {value.name}
                                              </option>
                                            )
                                          )}
                                      </Field>
                                      <Form.Control.Feedback type="invalid">
                                        {get(error, "ministry.message")}
                                      </Form.Control.Feedback>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <div className="decision-form-input-container">
                                <Form.Group className="field-datepicker m-0">
                                  <Form.Label className="decision-meeting-label p-0">
                                    Issue Resolution Date
                                  </Form.Label>
                                  <div className="form-field meeting-date datepicker">
                                    <DatePicker
                                      isClearable={taskCompletionDate}
                                      selected={taskCompletionDate}
                                      disabled={
                                        previousIssueStatusId ===
                                          resolvedIssueStatusId && isEditMode
                                      }
                                      onChange={value => {
                                        this.onChange(
                                          value,
                                          "taskCompletionDate"
                                        );
                                        this.onError(
                                          value,
                                          "taskCompletionDate"
                                        );
                                      }}
                                    />
                                  </div>
                                </Form.Group>
                              </div> */}
                            </Form.Group>
                          </div>
                        ) : null}
                        {get(issues, "secondaryMinistryId") ||
                        get(issues, "secondaryStateId") ? (
                          <>
                            <Form.Label className="p-0">
                              Secondary Recipient
                            </Form.Label>
                            <div className="select-issue-content add-decision-meeting w-full">
                              <Form.Group className="m-0">
                                <div className="decision-issue-status">
                                  <Form.Group className="field-select field-location form-field d-flex flex-row align-items-center justify-content-between m-0">
                                    <div className="decision-form-input-container">
                                      <Form.Label className="p-0 color-secondary">
                                        {(get(
                                          issues,
                                          "recipientGroupCategory"
                                        ) == "STATE" &&
                                          !this.state.stateMinistry) ||
                                        this.state.MinistryState
                                          ? "Central Ministry"
                                          : "State"}
                                      </Form.Label>
                                      <div className="added-location-wrapper">
                                        <div className="added-location-detail action-items-select assign-to-target">
                                          <div className="location-name">
                                            <Field
                                              keyName={
                                                (get(
                                                  issues,
                                                  "recipientGroupCategory"
                                                ) == "STATE" &&
                                                  !this.state.stateMinistry) ||
                                                this.state.MinistryState
                                                  ? "secondaryMinistryId"
                                                  : "secondaryStateId"
                                              }
                                              as="select"
                                              onBlur={this.onBlur}
                                              className="decision-select-field"
                                              onChange={this.onChange}
                                              // disabled={
                                              //   this.state.disabledSecondary
                                              // }
                                              value={
                                                secondaryMinistryId
                                                  ? secondaryMinistryId
                                                  : secondaryStateId
                                              }
                                            >
                                              <option value="">
                                                {" "}
                                                {(get(
                                                  issues,
                                                  "recipientGroupCategory"
                                                ) == "STATE" &&
                                                  !this.state.stateMinistry) ||
                                                this.state.MinistryState
                                                  ? "Select Central Ministry"
                                                  : "Select State"}
                                              </option>
                                              {this.state.CENTRAL.map(
                                                (value, idx) => (
                                                  <option
                                                    value={value.id}
                                                    key={`${value.id}-${idx}`}
                                                  >
                                                    {value.name}
                                                  </option>
                                                )
                                              )}
                                            </Field>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="decision-form-input-container">
                                      <Form.Label className="p-0 color-secondary">
                                        {(get(
                                          issues,
                                          "recipientGroupCategory"
                                        ) == "STATE" &&
                                          !this.state.stateMinistry) ||
                                        this.state.MinistryState
                                          ? "Central Department"
                                          : "State District/Department"}
                                      </Form.Label>
                                      <div className="added-location-wrapper">
                                        <div className="added-location-detail action-items-select assign-to-target">
                                          <div className="location-name">
                                            <Field
                                              keyName={
                                                (get(
                                                  issues,
                                                  "recipientGroupCategory"
                                                ) == "STATE" &&
                                                  !this.state.stateMinistry) ||
                                                this.state.MinistryState
                                                  ? "secondaryMinistryDepartmentId"
                                                  : "secondaryStateDepartmentId"
                                              }
                                              as="select"
                                              onBlur={this.onBlur}
                                              className="decision-select-field"
                                              onChange={this.onChange}
                                              // disabled={
                                              //   this.state.disabledSecondary
                                              // }
                                              value={
                                                (get(
                                                  issues,
                                                  "recipientGroupCategory"
                                                ) == "STATE" &&
                                                  !this.state.stateMinistry) ||
                                                this.state.MinistryState
                                                  ? secondaryMinistryDepartmentId
                                                  : secondaryStateDepartmentId
                                              }
                                            >
                                              <option value="">
                                                {" "}
                                                -
                                                {(get(
                                                  issues,
                                                  "recipientGroupCategory"
                                                ) == "STATE" &&
                                                  !this.state.stateMinistry) ||
                                                this.state.MinistryState
                                                  ? "Select Central Department"
                                                  : "Select State District/Department "}
                                                -
                                              </option>
                                              {isValidArray(
                                                secondaryDepartmentStateList
                                              ) &&
                                                secondaryDepartmentStateList.map(
                                                  (value, idx) => (
                                                    <option
                                                      value={value.id}
                                                      key={`${value.id}-${idx}`}
                                                    >
                                                      {value.name}
                                                    </option>
                                                  )
                                                )}
                                            </Field>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Form.Group>
                                </div>
                              </Form.Group>
                            </div>
                          </>
                        ) : get(issues, "secondaryRecipientGroupId") ? (
                          <>
                            <Form.Label className="p-0">
                              Secondary Recipient
                            </Form.Label>
                            <div className="select-issue-content add-decision-meeting w-full">
                              <Form.Group className="m-0">
                                <div className="decision-issue-status">
                                  <Form.Group className="field-select field-location form-field d-flex flex-row align-items-center justify-content-between m-0">
                                    <div className="decision-form-input-container">
                                      <Form.Label className="p-0 color-secondary">
                                        {this.state.districtDeptCase
                                          ? "State Department"
                                          : "District"}
                                      </Form.Label>
                                      <div className="added-location-wrapper">
                                        <div className="added-location-detail action-items-select assign-to-target">
                                          <div className="location-name">
                                            <Field
                                              keyName="secondaryRecipientGroupId"
                                              as="select"
                                              className="decision-select-field"
                                              onChange={this.onChange}
                                              onBlur={this.onBlur}
                                              // disabled={
                                              //   this.state.disabledSecondary
                                              // }
                                              value={secondaryRecipientGroupId}
                                            >
                                              <option value="">
                                                {" "}
                                                {this.state.districtDeptCase
                                                  ? "Select State Department"
                                                  : "Select District"}
                                              </option>
                                              {(
                                                secondaryStateDeptDistrict || []
                                              ).map((value, idx) => {
                                                return (
                                                  <option
                                                    value={value.id}
                                                    key={`option-key-${idx}`}
                                                  >
                                                    {value.name}
                                                  </option>
                                                );
                                              })}
                                            </Field>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <InnerLoader
                                      loading={
                                        isGroupLoading === STATUS.LOADING
                                      }
                                      className={"add-issue-loader"}
                                    />
                                  </Form.Group>
                                </div>
                              </Form.Group>
                            </div>
                          </>
                        ) : null}

                        <div className="decision-issue-status">
                          <Form.Group className="form-field d-flex flex-row align-items-center justify-content-between">
                            <div className="w-full">
                              <Form.Label className="p-0">
                                Minutes of Meetings{" "}
                                <span className="required">*</span>
                              </Form.Label>
                              <div className="form-field">
                                <Field
                                  as="textarea"
                                  keyName="description"
                                  onChange={this.onChange}
                                  onError={this.onError}
                                  value={description}
                                  isInvalid={get(error, "description.error")}
                                  className="mom-input"
                                  onBlur={this.onBlur}
                                  placeholder="Enter minutes of the meeting"
                                />
                                <Form.Control.Feedback type="invalid">
                                  {get(error, "description.message")}
                                </Form.Control.Feedback>
                              </div>
                            </div>
                          </Form.Group>
                        </div>
                      </Form.Group>

                      <div className="intermediate-task-container">
                        <h4 className="intermediate-section-heading">
                          INTERMEDIATE TASKS
                        </h4>
                        {(get(project, "workflowType") === "CENTRAL" ||
                          get(issues, "projectIssueDTO.workflowType") ===
                            "CENTRAL" ||
                          get(issues, "workflowType") === "CENTRAL") &&
                        groupCategory === "PMG" ? (
                          <div className="decision-issue-status">
                            <Form.Group className="container-alignment field-select field-location m-0">
                              <div className="decision-form-input-container">
                                <Form.Label>Task 1</Form.Label>
                                <div className="form-field">
                                  <Field
                                    type="text"
                                    keyName="task1"
                                    onChange={this.onChange}
                                    onError={this.onError}
                                    value={task1}
                                    onBlur={this.onBlur}
                                    isInvalid={!!task1CompletionDate && !task1}
                                    className="add-decision-input-field w-full"
                                    placeholder="Enter task 1"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {get(error, "task1.message")}
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                              <div className="decision-form-input-container">
                                <Form.Group className="field-datepicker m-0">
                                  <Form.Label className="decision-meeting-label p-0">
                                    Task 1 Completion Date
                                  </Form.Label>
                                  <div
                                    className={
                                      !!task1 && !task1CompletionDate
                                        ? "form-field meeting-date datepicker invalid-task-date"
                                        : "form-field meeting-date datepicker"
                                    }
                                  >
                                    <DatePicker
                                      isClearable={task1CompletionDate}
                                      selected={task1CompletionDate}
                                      onChange={value => {
                                        this.onChange(
                                          value,
                                          "task1CompletionDate"
                                        );
                                        this.onError(
                                          value,
                                          "task1CompletionDate"
                                        );
                                      }}
                                      isInvalid={
                                        !!task1 && !task1CompletionDate
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      This field is required.
                                    </Form.Control.Feedback>
                                  </div>
                                </Form.Group>
                              </div>
                            </Form.Group>
                          </div>
                        ) : null}

                        {(get(project, "workflowType") === "CENTRAL" ||
                          get(issues, "projectIssueDTO.workflowType") ===
                            "CENTRAL" ||
                          get(issues, "workflowType") === "CENTRAL") &&
                        groupCategory === "PMG" ? (
                          <div className="decision-issue-status">
                            <Form.Group className="container-alignment field-select field-location m-0">
                              <div className="decision-form-input-container">
                                <Form.Label>Task 2</Form.Label>
                                <div className="form-field">
                                  <Field
                                    type="text"
                                    keyName="task2"
                                    onChange={this.onChange}
                                    onError={this.onError}
                                    value={task2}
                                    onBlur={this.onBlur}
                                    isInvalid={!!task2CompletionDate && !task2}
                                    className="add-decision-input-field w-full"
                                    placeholder="Enter task 2"
                                  />
                                  <Form.Control.Feedback type="invalid">
                                    {get(error, "task2.message")}
                                  </Form.Control.Feedback>
                                </div>
                              </div>
                              <div className="decision-form-input-container">
                                <Form.Group className="field-datepicker m-0">
                                  <Form.Label className="decision-meeting-label p-0">
                                    Task 2 Completion Date
                                  </Form.Label>
                                  <div
                                    className={
                                      !!task2 && !task2CompletionDate
                                        ? "form-field meeting-date datepicker invalid-task-date"
                                        : "form-field meeting-date datepicker"
                                    }
                                  >
                                    <DatePicker
                                      isClearable={task2CompletionDate}
                                      selected={task2CompletionDate}
                                      onChange={value => {
                                        this.onChange(
                                          value,
                                          "task2CompletionDate"
                                        );
                                        this.onError(
                                          value,
                                          "task2CompletionDate"
                                        );
                                      }}
                                      isInvalid={
                                        !!task2 && !task2CompletionDate
                                      }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                      This field is required.
                                    </Form.Control.Feedback>
                                  </div>
                                </Form.Group>
                              </div>
                            </Form.Group>
                          </div>
                        ) : null}
                      </div>

                      <DisplayAttachments
                        onTogglePopUp={onToggleAttachment}
                        filesArr={files}
                        onRemoveFile={onRemoveFile}
                        isAgendaAttachment={true}
                        buttonTitle="ADD DOCUMENT(S)"
                      />
                      <ButtonToolbar
                        className={`agenda-btn-container decision-btn-container ${
                          issueListStatus
                            ? "justify-content-around"
                            : "justify-content-end important-class"
                        }`}
                      >
                        {isEditMode ? (
                          <Button
                            className="btn-orange no-padding add-decision-meeting-btn"
                            onClick={this.onChildIssuePopUp}
                          >
                            EDIT DECISION
                          </Button>
                        ) : (
                          <Button
                            className="btn-orange no-padding add-decision-meeting-btn"
                            onClick={this.onChildIssuePopUp}
                          >
                            ADD DECISION
                          </Button>
                        )}

                        {showSaveAsDraft ? (
                          <Button
                            className="btn-orange-invert no-padding add-decision-btn mr-0"
                            onClick={this.saveAddDraftDecision}
                          >
                            SAVE AS DRAFT
                          </Button>
                        ) : null}
                      </ButtonToolbar>
                    </div>
                  </div>
                </div>
              </>
            )}
            <h3 className="add-decision-heading px-36px decision-number-heading">
              {ISSUE_DECISION_DETAILS.MOM_HEADER_TITLE} (
              {isValidArray(get(issues, "meetingDecisionDTOS", []))
                ? !viewMoreStatus
                  ? get(issues, "meetingDecisionDTOS", []).length - 1
                  : get(issues, "meetingDecisionDTOS", []).length
                : 0}
              )
            </h3>

            {get(issues, "meetingDecisionDTOS") &&
              get(issues, "meetingDecisionDTOS", []).map((value, idx) => (
                <React.Fragment>
                  {viewMoreStatus ? (
                    <div
                      className="select-issue-wrapper issue-view mx-36px"
                      key={`agenda--${idx}`}
                    >
                      <AgendaDecision
                        agendaData={agendaData}
                        agendaDetail={value}
                        listStatus={false}
                        redirectToAgenda={redirectToAgenda}
                      />
                      <div className="select-issue-content add-decision-issues">
                        <MOMDesc meeting={value} issues={issues} />
                      </div>
                    </div>
                  ) : get(value, "meetingId") !== get(agendaData, "id") ? (
                    <div
                      className="select-issue-wrapper issue-view mx-36px"
                      key={`agenda--${idx}`}
                    >
                      <AgendaDecision
                        agendaData={agendaData}
                        agendaDetail={value}
                        listStatus={false}
                        redirectToAgenda={redirectToAgenda}
                      />
                      <div className="select-issue-content add-decision-issues">
                        <MOMDesc meeting={value} issues={issues} />
                      </div>
                    </div>
                  ) : null}
                </React.Fragment>
              ))}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    isApiLoading: state.addDecisionReducer.isApiLoading,
    issuesStates: state.createProjectReducer.issuesStates
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addDecisionDispatch: addDecisionAction,
      getMinistryListDispatch: getMinistryListAction,
      getMomDetailsDispatch: getMomDetails,
      getIssuesStatesDispatch: getIssuesStatesAction,
      getGroupCategoryIdDispatch: getGroupCategoryIdAction,
      getGroupByCategoryAndParentId: getGroupByCategoryAndParentId
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDecision);
